
export const roundToOneDecimal = (inNum: number) => Math.round(inNum * 10) / 10;